import GenericUtils from "../../utils/GenericUtils";
import SelectOption from "../SelectOption";
import { UserRole } from "./UserRoleEnum";

export enum Routes {
    Inicio = "",
    Importar = "importar",
    Historico = "historico",
    ParametrizarPlanoAtividade = "parametrizar-tach",
    MeuPlano = "meu-tach",
    ConsultarPlano = "consultar-tach",
    EditarPlano = "editar-tach",
    GestaoTarefa = "gestao-tarefas",
    Calendario = "calendario",
    MinhaAgenda = "minha-agenda",
    ConsultarAgenda = "consultar-agenda",
    EditarAgenda = "editar-agenda",
    ChekinParametro = "chekin-parametros",
    AssociacaoAtividade = "associacao-atividade",
    AssociacaoCoordenador = "associacao-coordenador",
    GestaoUsuario = "gestao-usuarios",
    GerenciarPermissao = "gerenciar-permissao",
    WorkflowAbono = "workflow-abono",
    GerenciarAbono = "gerenciar-abono",
    Workflows = "workflows",
    Relatorios = "relatorios",
    EditorTermosDeAceite = "termo-de-aceite",
    Help = "help",
    AdministradorTach = "administrador-tach",
    HistoricoTach = "historico-tach",
    MeuPainelDocente = "meu-painel",
}

export const RoutesLabel = new Map<Routes, string>([
    [Routes.Inicio, "Início"],
    [Routes.Importar, "Importar Arquivos"],
    [Routes.Historico, "Arquivos Importados"],
    [Routes.ParametrizarPlanoAtividade, "Parametrizar TACH"],
    [Routes.MeuPlano, "Meu TACH"],
    [Routes.ConsultarPlano, "Consultar TACH"],
    [Routes.EditarPlano, "Editar TACH"],
    [Routes.GestaoTarefa, "Aprovar TACH"],
    [Routes.Calendario, "Calendário da Agenda"],
    [Routes.MinhaAgenda, "Minha Agenda"],
    [Routes.ConsultarAgenda, "Consultar Agenda"],
    [Routes.EditarAgenda, "Editar Agenda"],
    [Routes.ChekinParametro, "Parametrização de Check-in"],
    [Routes.AssociacaoAtividade, "Associação de Atividade"],
    [Routes.AssociacaoCoordenador, "Associação de Coordenador"],
    [Routes.GestaoUsuario, "Gestão de Usuários"],
    [Routes.GerenciarPermissao, "Gerenciar Permissões"],
    [Routes.WorkflowAbono, "Aprovações"],
    [Routes.GerenciarAbono, "Motivo de Abono"],
    [Routes.Workflows, "Aprovações"],
    [Routes.Relatorios, "Relatórios"],
    [Routes.Help, "Help"],
    [Routes.EditorTermosDeAceite, "Termo de Aceite"],
    [Routes.AdministradorTach, "Administrador TACH"],
    [Routes.HistoricoTach, "Histórico TACH"],
    [Routes.MeuPainelDocente, "Meu Painel"],
]);

const RoutesUserRole = new Map<Routes, UserRole>([
    [Routes.Importar, UserRole.Importacao],
    [Routes.Historico, UserRole.HistoricoImportacao],
    [Routes.ParametrizarPlanoAtividade, UserRole.ParametrizacaoPlanoAtividade],
    [Routes.MeuPlano, UserRole.PlanoAtividade],
    [Routes.AssociacaoCoordenador, UserRole.AssociacaoProfessorCoordenador],
    [Routes.AssociacaoAtividade, UserRole.AssociacaoAtividadeProfessor],
    [Routes.GestaoUsuario, UserRole.GestaoUsuario],
    [Routes.GestaoTarefa, UserRole.Workflow],
    [Routes.GerenciarPermissao, UserRole.GestaoPermissaoPlanoAtividade],
    [Routes.Calendario, UserRole.GestaoCalendario],
    [Routes.MinhaAgenda, UserRole.AgendaDocente],
    [Routes.EditarAgenda, UserRole.EditarAgendaDocente],
    [Routes.ConsultarAgenda, UserRole.VisualizarAgendaDocente],
    [Routes.ConsultarPlano, UserRole.VisualizarPlanoAtividade],
    [Routes.EditarPlano, UserRole.PlanoAtividadeDocente],
    [Routes.EditarPlano, UserRole.EditarPlanoAtividadeDocente],
    [Routes.ChekinParametro, UserRole.ParametrizacaoCheckin],
    [Routes.GerenciarAbono, UserRole.GestaoAbonoLegal],
    [Routes.Workflows, UserRole.GestaoWorkflow],
    [Routes.Relatorios, UserRole.Relatorios],
    [Routes.Help, UserRole.Help],
    [Routes.EditorTermosDeAceite, UserRole.TermoAceite],
    [Routes.AdministradorTach, UserRole.AdministradorTach],
    [Routes.HistoricoTach, UserRole.HistoricoTach],
    [Routes.MeuPainelDocente, UserRole.MeuPainelDocente],
]);

export const getOptionsRoutes = () => {
    const enumList = Array.from(RoutesLabel).map((item: any) => {
        return GenericUtils.impl<SelectOption>({
            value: String(item.at(0)),
            label: item.at(1),
        });
    });

    return enumList?.sort((a, b) => a.label.localeCompare(b.label));
};

export const getOptionsRoutesUserRole = () => {
    return Array.from(RoutesUserRole).map((item: any) => {
        return GenericUtils.impl({
            routes: String(item.at(0)),
            userRole: item.at(1),
        });
    });
};

export const getLabelRoutes = (value: Routes | null) => {
    if (!value) return "";

    return RoutesLabel.get(value) || "";
};

export const getRouteFromName = (name: string): Routes | undefined => {
    const routeKeys = Object.keys(Routes) as (keyof typeof Routes)[];
    const matchingRouteKey = routeKeys.find((key) => Routes[key] === name);

    return matchingRouteKey ? Routes[matchingRouteKey] : undefined;
};

export const getUserRoleByRoute = (value: Routes | undefined) => {
    if (!value) return null;

    return RoutesUserRole.get(value) || null;
};

export const getValueRoutes = (label: string) => {
    const value = getOptionsRoutes()?.find(
        (item) => item?.label?.toLowerCase() === label?.toLowerCase()
    )?.value;
    return Number(value);
};

export const getValueRoutesByUserRole = (role: number) => {
    return getOptionsRoutesUserRole()?.find((item) => item.userRole === role)
        ?.routes;
};

export const getRoutesEnumFromString = (route: string): Routes | null => {
    const enumValues = Object.values(Routes);
    const enumValue = enumValues.find((value) => value === route) as
        | Routes
        | undefined;

    return enumValue ?? null;
};
